import type {TimeZone} from '@hconnect/uikit/src/common'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {parseTimeRangeParamToDateRange} from '../utils'

import {useStoppageAnalysisPageParams} from './useStoppageAnalysisPageParams'

type UseDateRangeParams = {
  timezone: TimeZone
}

export const useStoppageAnalysisDateRange = ({timezone}: UseDateRangeParams) => {
  const {timeRangeParam} = useStoppageAnalysisPageParams()
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return useMemo(
    () => parseTimeRangeParamToDateRange({timeRange: timeRangeParam, timezone, t}),
    [timeRangeParam, timezone, t]
  )
}
